import { FC } from 'react';
import { useFormikContext } from 'formik';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import CleanIcon from '@mui/icons-material/CleaningServices';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Form from 'components/Form';
import Storage from 'components/DiskCleanupStorage';
import Media from 'components/DiskCleanupMedia';
import SelectAll from 'components/DiskCleanupSelectAll';

import { useDiskCleanup, useTools } from 'components/DiskCleanupContext';

import { DiskCleanupFormValues } from 'components/DiskCleanup';
import { DiskCleanupForm_data$key } from '__generated__/DiskCleanupForm_data.graphql';

type Props = {
  data: DiskCleanupForm_data$key;
  loading?: boolean;
};

const DiskCleanupForm: FC<Props> = props => {
  const { loading = false } = props;
  const tools = useTools();
  const { loading: scanLoading } = useDiskCleanup();

  const data = useFragment(
    graphql`
      fragment DiskCleanupForm_data on Query {
        ...DiskCleanupMedia_data
        ...DiskCleanupStorage_data
      }
    `,
    props.data
  );

  const { values } = useFormikContext<DiskCleanupFormValues>();

  const disabled = tools.reduce(
    (acc, tool) => acc && !values[tool].selected,
    true
  );

  return (
    <Form
      disabled={disabled || scanLoading}
      loading={loading}
      icon={<CleanIcon />}
      tooltip="Valyti">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <SelectAll tools={tools} />
            </TableCell>

            <TableCell>Failai</TableCell>
            <TableCell>Parametrai</TableCell>
            <TableCell>Dydis</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          <Media data={data} />
          <Storage data={data} />
        </TableBody>
      </Table>
    </Form>
  );
};

export default DiskCleanupForm;
